// Labels shown in device table headers and the column picker (single source of truth).

import type { ExtraColumnKey } from '../../../../types/DeviceListTypes';

/** Extra columns not user-toggleable (folded into row UI). */
export const EXTRA_COLUMNS_HIDDEN_FROM_PICKER = new Set<ExtraColumnKey>([
  '__busy',
  '__busy_from',
  '__busy_reason',
  '__lifecycle_note',
]);

export const EXTRA_COLUMN_HEADER_LABELS: Record<ExtraColumnKey, string> = {
  __online: 'Online?',
  __mode: 'Mode',
  __fw: 'Firmware',
  __modem_fw: 'Modem FW',
  __gnss_fw: 'GNSS FW',
  __batt: 'Battery (V)',
  __last: 'Last Status',
  __tls: 'Provisioned?',
  __lifecycle_lost: 'Lost',
  __lifecycle_decommissioned: 'Decommissioned',
  __lifecycle_damaged: 'Damaged',
  __lifecycle_errored: 'Errored',
  __lifecycle_note: 'Lifecycle note',
  __attr_race_count: 'Race count',
  __attr_waterproofed_by: 'Waterproofed by',
  __race_log: 'Race log (B)',
  __debug_log: 'Debug log (B)',
  __batt_ma: 'Battery (mA)',
  __reason: 'Last cmd feedback',
  __gga: 'Location',
  __location_updated: 'Location Updated',
  __last_cmd_id: 'Last Cmd Response',
  __last_cmd_type: 'Last Cmd Type',
  __last_cmd_target: 'Last Cmd Target',
  __last_cmd_status: 'Last Cmd Status',
  __last_cmd_ack_percent: 'Cmd Progress',
  __last_cmd_updated: 'Cmd Updated At',
  __busy: '',
  __busy_from: '',
  __busy_reason: '',
};

export function extraColumnHeaderLabel(key: ExtraColumnKey): string {
  return EXTRA_COLUMN_HEADER_LABELS[key] || String(key);
}
